<template>
    <div class="student-login" :style="{background: globalConfig.exam_result_check.image?`url(${globalConfig.exam_result_check.image}) 100% 100% no-repeat`:`url(${defaultBg}) 100% 100% no-repeat`}">
        <div class="login-title">{{globalConfig.exam_result_check.name}}</div>
        <img class="tc1" src="../assets/studentLogin/tc1.png">
        <img class="tc2" src="../assets/studentLogin/tc1.png">
            <div class="form-body">
                <div class="content">
                    <div class="info">
                        <div class="name">姓名：{{params.name}}</div>
                        <div class="name" style="left: 300px;">身份证：{{params.card_num}}</div>
                        <div v-if="examInfo.length===0&&resultInit" class="tips">未查询到相关成绩</div>
                        <div class="table">
                            <div class="table-header">
                                <div class="item1 header-item">级别</div>
                                <div class="item2 header-item">考试时间</div>
                                <div class="item3 header-item">综合成绩</div>
                                <div class="item4 header-item">说明</div>
                            </div>
                            <div v-for="(item, index) in examInfo" :key="index" class="row">
                                <div class="item1 item" :title="item.type">{{item.type}}</div>
                                <div class="item2 item" :title="item.start_time">{{item.start_time}}</div>
                                <div class="item3 item" :title="item.total_score">{{item.is_pass}}</div>
                                <div class="item4 item" :title="item.desc">{{item.desc}}</div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
    </div>
    
</template>
<script>
// import { MessageBox } from 'element-ui';
import { mapState } from 'vuex';


export default {
    data(){
        return {
            defaultBg: require('../assets/studentLogin/bg.png'),
            params:{},
            examInfo: [],
            resultInit: false,
        };
    },
    computed:mapState([
        'globalConfig',
        'userInfo',
    ]),
    watch:{
        
    },
    mounted() {
        if(!localStorage.getItem('cfda_gradeSearch')){
            this.$router.push('/searchScore');
            return;
        }
        this.params = JSON.parse(localStorage.getItem('cfda_gradeSearch'));
        this.getResult();
    },
    methods: {
        async getResult(){
            try {
                const res = await this.$http.get('/api/exam/getExamResult',this.params);
                if(res){
                    this.examInfo = res;
                    this.resultInit = true;
                }
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.tips{
    text-align: center;
    font-weight: 700;
    font-size: 30px;
    padding-top: 100px;
}
.student-login{
    width: 100%;
    min-width: 1200px;
    height: 100vh;
    min-height: 600px;
    position: relative;
}
.tc1{
    width: 800px;
    height: 400px;
    position: absolute;
    top: calc(50% - 150px);
    left: calc(50% - 400px);
    z-index: 9;
}
.tc2{
    width: 760px;
    height: 360px;
    position: absolute;
    top: calc(50% - 130px);
    left: calc(50% - 380px);
    z-index: 99;
}


@import '../assets/user.scss';

.ext{
    position: relative;
    .ext-input{
        // width:80px;
    }
    .get-code{
        position: absolute;
        right: 135px;
        top: 20px;
        border-radius: 4px;
        padding: 6px 6px;
        background: #002c56;
        color: #fff;
        font-size: 13px;
    }
}
.control-label{
    font-family: Microsoft YaHei !important;
    font-weight: bold !important;
    color: #000000 !important;
}

.form-body{
    width: 400px;
    position: absolute;
    left: calc(50% - 200px);
    top: calc(50% - 70px);
    z-index: 999;
}
.my-btn{
    background: #002E67;
    padding: 5px 28px;
    border-radius: 3px;
    color: #fff;
    position: absolute;
    font-weight: bold;
    display: inline-block;
    bottom: -63px;
    left: 102px;
    cursor: pointer;
}
.reset-btn{
    border: 1px solid #002E67 !important;
    color: #002E67 !important;
    left: 278px !important;
    background: #fff !important;
}
.login-title{
    text-align: center;
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    padding-top: 80px;
}

.content{
        position: absolute;
        left: 50%;
        top: 55%;
        width: 860px;
        height: 450px;
        z-index: 999;
        font-size: 18px;
        margin-left: -430px;
        margin-top: -114px;
        border-radius: 10px;
        padding: 56px 50px 35px;
        box-sizing: border-box;
        .info{
            overflow: hidden;
            position: relative;
            height: 100%;
            .name{
                position: absolute;
                top: 20px;
                left: 115px;
                font-weight:bold;
            }
            .total{
                text-align: center;
                float: left;
                .mgc{
                    width: 260px;
                    height: 260px;
                    position: relative;
                    img{
                        position: absolute;
                        width: 100%;
                        top: 0;
                        left: 0;
                    }
                    .score{
                        position: absolute;
                        font-size: 46px;
                        top: 0px;
                        left: 0;
                        text-align: center;
                        width: 100%;
                        height: 260px;
                        line-height: 260px;
                        color: #fff;
                        display: flex;
                        justify-content: center;
                        align-items: baseline;
                        .unit{
                            font-size: 28px;
                        }
                    }
                }
                .tz{
                    font-size: 20px;
                    font-weight: bold;
                }
                .qualified{
                    color: #002E67;
                }
                .unqualified{
                    color: #B3B3B3;
                }
                .wait{
                    color: #808080;
                }
            }
        }
    }
    
    .table{
        width: calc(100% - 40px);
        margin-left: 20px;
        margin-top: 70px;
        .table-header{
            width: 100%;
            height: 28px;
            line-height: 28px;
            background: #DAF0FB;
            display: flex;
            font-size: 16px;
        }
        .row{
            width: 100%;
            display: flex;
            vertical-align: middle;
        }
        .header-item{
            height: 28px;
            line-height: 28px;
            text-align: center;
            box-sizing: border-box;
            border: 0px !important;
            font-size: 16px !important;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000;
        }
        .item{
            padding: 17px 5px;
            text-align: center;
            background: rgba(255, 255, 255, 0.3);
            box-sizing: border-box;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000;
        }
        .item1{
            width: 15%;
            border-left: 1px solid #4D4D4D;
            border-bottom: 1px solid #4D4D4D;
        }
        .item2{
            width: 20%;
            border-left: 1px solid #4D4D4D;
            border-bottom: 1px solid #4D4D4D;
        }
        .item3{
            width: 15%;
            border-left: 1px solid #4D4D4D;
            border-bottom: 1px solid #4D4D4D;
        }
        .item4{
            width: 50%;
            border-left: 1px solid #4D4D4D;
            border-bottom: 1px solid #4D4D4D;
            border-right: 1px solid #4D4D4D;
        }
    }
</style>
